import React, { useEffect, useState } from "react";

import Modal from "react-modal";

import * as api from "../../api";
import * as notify from "../../notify";
import "../../stylesheets/UserManagementActions.css";
import VtUserManagementEditUser from "./VtUserManagementEditUser";

const VtUserManagementRowActions = (props) => {
  const { onUpdated, setShowEditModal, showEditModal, user } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  const profileId = user.subId || user.id;
  const userLabel =
    user.email ||
    `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
    "this user";
  const accountStatus = user.status;
  const isEnabled = accountStatus === "enabled";
  const isDisabled = accountStatus === "disabled";

  useEffect(() => {
    const handleCloseDropdown = (event) => {
      if (!event.target.closest(".vt-user-actions")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mouseup", handleCloseDropdown);
    return () => {
      document.removeEventListener("mouseup", handleCloseDropdown);
    };
  }, []);

  const closeConfirm = () => {
    if (!actionLoading) {
      setConfirmAction(null);
    }
  };

  const handleConfirm = () => {
    if (!profileId || actionLoading || !confirmAction) {
      return;
    }

    if (confirmAction === "resend") {
      setActionLoading(true);
      api.resendVtUserManagementInvitation(profileId).then((response) => {
        setActionLoading(false);
        if (
          response &&
          response.status === 200 &&
          !(response.data && response.data.code)
        ) {
          notify.success("Invitation resent", true);
          setConfirmAction(null);
        } else {
          notify.error("Failed to resend invitation");
        }
      });
      return;
    }

    const nextStatus = confirmAction === "enable" ? "enabled" : "disabled";
    setActionLoading(true);
    api
      .setVtUserManagementUserStatus(profileId, nextStatus)
      .then((response) => {
        setActionLoading(false);
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.status === "SUCCESS"
        ) {
          notify.success(`User ${confirmAction}d`, true);
          setConfirmAction(null);
          if (onUpdated) {
            onUpdated();
          }
        } else {
          notify.error(`Failed to ${confirmAction} user`);
        }
      });
  };

  const getConfirmContent = () => {
    switch (confirmAction) {
      case "resend":
        return {
          title: `Resend invitation to ${userLabel}?`,
          confirmLabel: actionLoading ? "Sending..." : "Resend",
        };
      case "enable":
        return {
          title: `Enable ${userLabel}?`,
          confirmLabel: actionLoading ? "Enabling..." : "Enable",
        };
      case "disable":
        return {
          title: `Disable ${userLabel}? They will no longer be able to sign in.`,
          confirmLabel: actionLoading ? "Disabling..." : "Disable",
        };
      default:
        return null;
    }
  };

  const confirmContent = getConfirmContent();

  return (
    <>
      <div className="vt-user-actions dropdown">
        <button
          type="button"
          className="vt-user-actions-button"
          aria-label="User actions"
          aria-expanded={showDropdown}
          onClick={(event) => {
            event.stopPropagation();
            setShowDropdown(!showDropdown);
          }}
        >
          ⋮
        </button>
        <div
          className={
            showDropdown
              ? "dropdown-content vt-user-actions-menu show"
              : "dropdown-content vt-user-actions-menu"
          }
        >
          <button
            type="button"
            onClick={() => {
              setShowDropdown(false);
              setShowEditModal(true);
            }}
          >
            Edit User
          </button>
          <button
            type="button"
            onClick={() => {
              setShowDropdown(false);
              setConfirmAction("resend");
            }}
          >
            Resend Invitation
          </button>
          {isEnabled ? (
            <button
              type="button"
              onClick={() => {
                setShowDropdown(false);
                setConfirmAction("disable");
              }}
            >
              Disable User
            </button>
          ) : null}
          {isDisabled ? (
            <button
              type="button"
              onClick={() => {
                setShowDropdown(false);
                setConfirmAction("enable");
              }}
            >
              Enable User
            </button>
          ) : null}
        </div>
      </div>

      <VtUserManagementEditUser
        user={user}
        onUpdated={onUpdated}
        showModal={showEditModal}
        onRequestClose={() => setShowEditModal(false)}
      />

      {confirmContent ? (
        <Modal
          isOpen={!!confirmAction}
          shouldCloseOnOverlayClick={!actionLoading}
          onRequestClose={closeConfirm}
          className="Modal cancel-confirm"
          overlayClassName="Overlay"
          ariaHideApp={false}
        >
          <h3>{confirmContent.title}</h3>
          <div>
            <button
              className="proview-button cancel left"
              onClick={closeConfirm}
              type="button"
              disabled={actionLoading}
            >
              Cancel
            </button>
            <button
              className="proview-button right"
              onClick={handleConfirm}
              type="button"
              disabled={actionLoading}
            >
              {confirmContent.confirmLabel}
            </button>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default VtUserManagementRowActions;
